export default __webpack_public_path__ + "maps-examples-animate-image-layer-thumbnail-480-10a773395100bc72f1d6ef5114dff8e9.webp";